/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PharmacySection } from './PharmacySection';
import {
    PharmacySectionFromJSON,
    PharmacySectionFromJSONTyped,
    PharmacySectionToJSON,
    PharmacySectionToJSONTyped,
} from './PharmacySection';

/**
 * 
 * @export
 * @interface Pharmacy
 */
export interface Pharmacy {
    /**
     * 
     */
    sections?: Array<PharmacySection>;
}

/**
 * Check if a given object implements the Pharmacy interface.
 */
export function instanceOfPharmacy(value: object): value is Pharmacy {
    return true;
}

export function PharmacyFromJSON(json: any): Pharmacy {
    return PharmacyFromJSONTyped(json, false);
}

export function PharmacyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pharmacy {
    if (json == null) {
        return json;
    }
    return {
        
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(PharmacySectionFromJSON)),
    };
}

export function PharmacyToJSON(json: any): Pharmacy {
    return PharmacyToJSONTyped(json, false);
}

export function PharmacyToJSONTyped(value?: Pharmacy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(PharmacySectionToJSON)),
    };
}

